import { MoodysRating, MOODY_RATINGS, RATINGS_REVERSED_LIST } from "@goodfill/domain-properties";
import { FilterSimpleSelectBox } from "../../../filters/FilterSimpleSelectBox";
import { Range, RangeColumnDefinition, rangeFilter } from "../generic/RangeColumnDefinition";
import { nullableComparator, numberComparator } from "@goodfill/sort";

export const MOODYS_RATING_CRITERIA_KEY = "ratingMoody";

type Value = MoodysRating | null; // Rating can be missing
type CriteriaValue = Range<Value>;
type Criteria = { [MOODYS_RATING_CRITERIA_KEY]: CriteriaValue };
type FilterChangeFunction = (key: typeof MOODYS_RATING_CRITERIA_KEY, value: CriteriaValue) => void;

export const moodysRatingFilter = <TItemKey extends string>(itemKey: TItemKey) =>
  rangeFilter<typeof MOODYS_RATING_CRITERIA_KEY, TItemKey, Value>(MOODYS_RATING_CRITERIA_KEY, itemKey, (a, b) => {
    // Todo: getBondRatingIndicesWithOffsetForMissingRating should be used, but it needs S&P as well
    const iA = a !== null ? RATINGS_REVERSED_LIST.moodys.indexOf(a) : null;
    const iB = b !== null ? RATINGS_REVERSED_LIST.moodys.indexOf(b) : null;

    return nullableComparator(numberComparator)(iA, iB, {}, {});
  });

export const MoodysRatingFilterComponent = ({
  criteria,
  onFilterChange,
}: { criteria: Criteria; onFilterChange: FilterChangeFunction }) => {
  const [left, right] = criteria[MOODYS_RATING_CRITERIA_KEY];

  return (
    <div className="flex flex-row">
      <FilterSimpleSelectBox
        small
        options={MOODY_RATINGS.map((a) => `${a}`)}
        onChange={(value) =>
          onFilterChange(MOODYS_RATING_CRITERIA_KEY, [value !== null ? (value as MoodysRating) : null, right])
        }
        value={left}
      />
      <FilterSimpleSelectBox
        small
        options={MOODY_RATINGS.map((a) => `${a}`)}
        onChange={(value) =>
          onFilterChange(MOODYS_RATING_CRITERIA_KEY, [left, value !== null ? (value as MoodysRating) : null])
        }
        value={right}
      />
    </div>
  );
};

export const MoodysRatingColumnDefinition = <TItemKey extends string>(
  itemKey: TItemKey,
  criteria: Criteria,
  onFilterChange: FilterChangeFunction,
) =>
  RangeColumnDefinition(
    "Moody's",
    itemKey,
    MOODYS_RATING_CRITERIA_KEY,
    criteria,
    onFilterChange,
    () => <MoodysRatingFilterComponent criteria={criteria} onFilterChange={onFilterChange} />,
    (row) => <>{row[itemKey]}</>,
    200,
  );
